<div
  class="container"
  [ngClass]="{
    half_width: isServiceBuyer
  }"
>
  <div class="report-content">
    <div class="report-download">
      <div *ngIf="isServiceBuyer" class="row padd-min-3">
        <label>Transaction Report</label>
      </div>
      <button
        class="btn btn-default"
        [disabled]="buttonDisabled"
        (click)="downloadTransactionReport()"
      >
        Download Report
      </button>
      <a
        class="gear"
        (click)="openCloumnsPreferenceModal()"
        *ngIf="showDynamicReportsOptions"
        ><i class="fa fa-2x fa-gear"></i
      ></a>

      <div class="include-test-checkbox-container">
        <input
          id="includeTests"
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="includeTestTransactions"
        />
        <label for="includeTests" class="include-test-checkbox-label">
          Include Test Transactions</label
        >
      </div>
    </div>
    <div
      *psUiHasRole="'operator'"
      class="vl vertical-pipe"
      [ngClass]="{
        vertical_pipe_service_operator: isServiceBuyer
      }"
    >
      <div class="report-subscribe">
        <button
          class="btn btn-default"
          [disabled]="csButtonDisabled"
          (click)="downloadCSTransactionReport()"
        >
          Download CS Report
        </button>
        <button
          class="btn btn-primary btn-subscribe-email"
          (click)="openSubscribeEmailModal()"
        >
          Subscribe
        </button>
      </div>
    </div>
    <div
      class="vl vertical-pipe"
      *psUiConfigEnabled="'enableSurveyDetailsReport'"
    >
      <div class="supplier-summary-download">
        <button
          class="btn btn-default"
          [disabled]="downloadSupplierSummaryDisabled"
          (click)="downloadSupplierSummaryReport()"
        >
          Download Supplier Summary
        </button>
      </div>
    </div>
  </div>
</div>
